export default "__VITE_ASSET__CZDBd2yV__$_?no-inline__"